import React from 'react'
import { mapLanguageToComponentProps } from 'i18n'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { I18nComponentType } from 'i18n-types'
import { Button, ButtonProps } from 'components/styled/button'

interface AddButtonProps extends ButtonProps {
  i18n: I18nComponentType
  type: 'submit' | 'button'
  height?: string
}

const StyledAddButton = styled(Button)<{ $height?: string }>`
  border-radius: 0;
  padding: 0;
  border-left: 1px solid ${({ theme }) => theme.color.grey20};
  color: ${({ theme }) => theme.color.bodyText};

  button {
    border-radius: 0;
    height: ${({ $height, theme }) => $height || theme.space.s40};
  }
`

export const AddButton = ({
  i18n,
  height,
  type = 'submit',
  ...props
}: AddButtonProps) => (
  <StyledAddButton
    type={type}
    $height={height}
    {...props}
    text={i18n.addButton.add}
  />
)

export default connect(mapLanguageToComponentProps())(AddButton)
